export default __webpack_public_path__ + "static/media/paytm-1.5787df9f.svg";